var _circle, _circle2, _path, _path2, _path3, _path4, _circle3, _circle4, _circle5, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangemarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FF4341"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C14.5 15.5147 16.5147 13.5 19 13.5C21.4853 13.5 23.5 15.5147 23.5 18V23.4H14.5V18Z",
    fill: "#FF4341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0977 19.7999C18.0977 19.3028 18.5006 18.8999 18.9977 18.8999C19.4947 18.8999 19.8977 19.3028 19.8977 19.7999V23.3999H18.0977V19.7999Z",
    fill: "#FFF8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6992 25.3999C12.6992 24.2953 13.5946 23.3999 14.6992 23.3999H23.2992C24.4038 23.3999 25.2992 24.2953 25.2992 25.3999V26.9999H12.6992V25.3999Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23.4V18C23.5 16.8065 23.0259 15.6619 22.182 14.818C21.3381 13.9741 20.1935 13.5 19 13.5C17.8065 13.5 16.6619 13.9741 15.818 14.818C14.9741 15.6619 14.5 16.8065 14.5 18V23.4M23.5 23.4C23.9774 23.4 24.4352 23.5896 24.7728 23.9272C25.1104 24.2648 25.3 24.7226 25.3 25.2V27H12.7V25.2C12.7 24.7226 12.8896 24.2648 13.2272 23.9272C13.5648 23.5896 14.0226 23.4 14.5 23.4M23.5 23.4H19H14.5M27.1 18H28M24.85 11.25L24.4 11.7M10 18H10.9M19 9V9.9M12.6361 11.6361L13.2724 12.2724",
    stroke: "#484848",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FF772B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.24 12.2545L26.6008 20.9353C27.3712 22.1821 26.9928 23.8224 25.7552 24.5987C25.3399 24.8601 24.8557 24.9995 24.3608 25H13.6384C12.1816 25 11 23.81 11 22.3408C11 21.8438 11.1384 21.3576 11.3984 20.9353L16.76 12.2545C17.5296 11.0077 19.1568 10.6258 20.3944 11.402C20.7368 11.6167 21.0264 11.9083 21.24 12.2545ZM19 21.8889C19.2122 21.8889 19.4157 21.8069 19.5657 21.6611C19.7157 21.5152 19.8 21.3174 19.8 21.1111C19.8 20.9048 19.7157 20.707 19.5657 20.5611C19.4157 20.4152 19.2122 20.3333 19 20.3333C18.7878 20.3333 18.5844 20.4152 18.4343 20.5611C18.2843 20.707 18.2 20.9048 18.2 21.1111C18.2 21.3174 18.2843 21.5152 18.4343 21.6611C18.5844 21.8069 18.7878 21.8889 19 21.8889ZM19 14.8888C18.7878 14.8888 18.5844 14.9708 18.4343 15.1166C18.2843 15.2625 18.2 15.4603 18.2 15.6666V18.7777C18.2 18.984 18.2843 19.1818 18.4343 19.3277C18.5844 19.4736 18.7878 19.5555 19 19.5555C19.2122 19.5555 19.4157 19.4736 19.5657 19.3277C19.7157 19.1818 19.8 18.984 19.8 18.7777V15.6666C19.8 15.4603 19.7157 15.2625 19.5657 15.1166C19.4157 14.9708 19.2122 14.8888 19 14.8888Z",
    fill: "#FF772B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.24 12.2545L26.6008 20.9353C27.3712 22.1821 26.9928 23.8224 25.7552 24.5987C25.3399 24.8601 24.8557 24.9995 24.3608 25H13.6384C12.1816 25 11 23.81 11 22.3408C11 21.8438 11.1384 21.3576 11.3984 20.9353L16.76 12.2545C17.5296 11.0077 19.1568 10.6258 20.3944 11.402C20.7368 11.6167 21.0264 11.9083 21.24 12.2545Z",
    stroke: "#484848",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangemarker);
export default __webpack_public_path__ + "static/media/orangemarker.c81d5e6cd3c52b5a20303d57ebf6ef76.svg";
export { ForwardRef as ReactComponent };